export default {
    usuariosApp(state) { //depreciar
        let res = [];
        let usuariosAuth = state.usuariosAuth;
        for (const user of state.usuarios) {
            let userAuthFound = usuariosAuth.find(e => e.uid == user.id)
            if (userAuthFound) {
                let roleObj = null;
                const found = state.roles.find(e => e.value == user.role);
                roleObj = {
                    text: 'Sin asignar',
                    value: null
                }
                if (found) {
                    roleObj = {
                        text: found.text,
                        value: found.value
                    }
                }
                let aux = {
                    ...user,
                    uid: userAuthFound.uid,
                    email: userAuthFound.email,
                    displayName: userAuthFound.displayName,
                    telefono: userAuthFound.phoneNumber,
                    activo: !userAuthFound.disabled,
                    role: roleObj,
                }
                res.push(aux)
            }
        }
        return res;
    },
    usuariosLigero(state) {
        return state.usuarios.map(u => {
            const found = state.roles.find(e => e.value == u.role);
            var roleObj = {
                text: 'Sin asignar',
                value: null
            }
            if (found) {
                roleObj = {
                    text: found.text,
                    value: found.value
                }
            }
            return {
                ...u,
                uid: u.id,
                role: roleObj,
            }
        })
    }
}